
const Status= {
    PUBLISHED: "PUBLISHED",
    DRAFT: "DRAFT"
}

export default Status;